import { HookResponse, ProjectAddress_DB } from "@models/Models";
import { useCallback } from "react";
import { ADDRESSES_TABLE_ID, db, DB_ID, id } from "@/appwrite";
import { toAddress } from "@/helpers/dbHelpers";

const useAddress = () => {

    const updateAddressRow = useCallback(async(updatedAddress: ProjectAddress_DB, id: string): Promise<HookResponse> => {
        try {
            const response = await db.updateRow({
                databaseId: DB_ID,
                tableId: ADDRESSES_TABLE_ID,
                rowId: id,
                data: updatedAddress
            });

            const address = toAddress(response);

            return {
                success: true,
                message: "Address updated successfully",
                data: address,
            };
        }catch (error: any) {
            console.log("Error updating address: ", error);
            return {
                success: false,
                message: error.message,
                data: null,
            };
        }
    }, []);

    const addAddressRow = useCallback(async(newAddress: ProjectAddress_DB): Promise<HookResponse> => {
        try {
            const response = await db.createRow({
                databaseId: DB_ID,
                tableId: ADDRESSES_TABLE_ID,
                rowId: id.unique(),
                data: newAddress
            });

            const address = toAddress(response);

            return {
                success: true,
                message: "Address added successfully",
                data: address,
            }
        } catch (error: any) {
            console.log("Error adding address: ", error);
            return {
                success: false,
                message: error.message,
                data: null,
            };
        }
    }, []);     
    
    const removeAddressRow = useCallback(async(rowId: string): Promise<HookResponse> => {
        try {
            await db.deleteRow({
                databaseId: DB_ID,
                tableId: ADDRESSES_TABLE_ID,
                rowId: rowId,
            });

            return {
                success: true,
                message: "Address removed successfully",
                data: null,
            }
        } catch (error: any) {
            console.log("Error removing address: ", error);
            return {
                success: false,
                message: error.message,
                data: null,
            };
        }
    }, []);     

    return {
        updateAddressRow,
        addAddressRow,
        removeAddressRow
    };
}

export default useAddress;